import React, { useEffect, useState } from "react";
import "./ModalBooking.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import {  useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL


const ModalBooking = ({ closeModal, cor_id }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState("");
  const [booked, setBooked] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  console.log(cor_id)

  useEffect(() => {
    const fetchBookedSlots = async () => {
      try {
        console.log("cor_id", cor_id);
        const response = await axios.get(
          `${BASE_URL}/api/v1/CoordinatorManagement/Get-Coordinator-MeetingTime/${cor_id}`
        );
        console.log("Booked time slots:", response.data?.data?.meeting_Slots);
        setBooked(response.data?.data?.meeting_Slots || []);  // Ensure it's always an array
      } catch (error) {
        console.error("Error fetching booked slots:", error);
        setBooked([]);  // Default to empty array on error
      }
    };
  
    fetchBookedSlots();
  }, [cor_id]);
  

  const times = [
    "9:00 AM-9:45 AM",
    "10:00 AM-10:45 AM",
    "11:00 AM-11:45 AM",
    "12:00 PM-12:45 PM",
    "1:00 PM-1:45 PM",
   "2:00 PM-2:45 PM",
    "3:00 PM-3:45 PM",
    "4:00 PM-4:45 PM",
    "5:00 PM-5:45 PM",
  ];

  const parseTimeString = (timeString, selectedDate) => {
    const [start, end] = timeString.split("-");
    const [startHour, startMinute, startPeriod] = start.split(/[:\s]/);
    const [endHour, endMinute, endPeriod] = end.split(/[:\s]/);

    const slotStartDate = new Date(selectedDate);
    const slotEndDate = new Date(selectedDate);

    slotStartDate.setHours(
      startPeriod === "PM" && parseInt(startHour) !== 12
        ? parseInt(startHour) + 12
        : parseInt(startHour)
    );
    slotStartDate.setMinutes(parseInt(startMinute));
    slotEndDate.setHours(
      endPeriod === "PM" && parseInt(endHour) !== 12
        ? parseInt(endHour) + 12
        : parseInt(endHour)
    );
    slotEndDate.setMinutes(parseInt(endMinute));

    return { slotStartDate, slotEndDate };
  };

  const isBooked = (timeString) => {
    if (!Array.isArray(booked)) {
      console.warn("booked is not an array", booked);
      return false;  // Return false so all times are available
    }
  
    const { slotStartDate, slotEndDate } = parseTimeString(timeString, startDate);
    return booked.some(({ start, end }) => {
      const bookedStart = new Date(start);
      const bookedEnd = new Date(end);
      return (
        (slotStartDate >= bookedStart && slotStartDate < bookedEnd) ||
        (slotEndDate > bookedStart && slotEndDate <= bookedEnd)
      );
    });
  };
  

  const availableTimes = times.filter((time) => !isBooked(time));

  const handleTimeClick = (time) => {
    setSelectedTime(time);
  };

 

  const handleSubmit = async () => {
    if (isSubmitting) return; // Prevent multiple clicks
  
    setIsSubmitting(true); // Disable button
  
    const { slotStartDate, slotEndDate } = parseTimeString(selectedTime, startDate);
    const newSlot = {
      start: slotStartDate.toISOString(),
      end: slotEndDate.toISOString(),
    };
  
    try {
      const response = await axios.put(
        `${BASE_URL}/api/v1/CoordinatorManagement/Add-Coordinator-MeetingTime/${cor_id}`,
        { meeting_Slots: [...booked, newSlot] }
      );
  
      console.log("Slot added:", response.data);
      alert(`Booked an Appointment with Event Coordinator on ${startDate.toLocaleDateString()} at ${selectedTime}`);
      closeModal();
      navigate("/user-dashboard");
    } catch (error) {
      console.error("Error adding time slot:", error);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  return (
    <section id="booking-modal-conatiner">
      <div className="modalBackground">
        <div className="modalBooking-container">
          <div className="close-button">
            <button onClick={() => closeModal(false)}>X</button>
          </div>
          <div className="modalBooking-title">
            <h3>Book an Appointment with Coordinator</h3>
          </div>
          <div className="modalBackground-body">
            <div className="booking-container">
              <div className="booking-content">
                <div className="custom-datepicker">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    inline
                    minDate={new Date()} // Disables previous days
                  />
                </div>
                <div className="times-container">
                  {availableTimes.map((time, index) => (
                    <button
                      key={index}
                      className={`time-button ${
                        selectedTime === time ? "selected" : ""
                      }`}
                      onClick={() => handleTimeClick(time)}
                    >
                      {time}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="modalBooking-footer">
            <button className="cancel-button" onClick={() => closeModal(false)}>
              Cancel
            </button>
            <button className="submit-button" onClick={handleSubmit} disabled={isSubmitting}>
  {isSubmitting ? "Submitting..." : "Submit"}
</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModalBooking;
